import { 
        Box,
        Grid, 
        Button,
        Typography, 
        InputLabel,
        FormControl,
        Select,
        MenuItem,
        TextField
 } from '@material-ui/core';
import LibrariesSlider from 'components/LibrarySlider';
import Interweave from 'interweave';
import { useTranslation } from 'react-i18next';
import { Search } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import LibraryData from 'services/dataService/LibraryData';
import { useStyles } from './styles';
import React, { useEffect, useState } from 'react';

export default () => {
  const classes = useStyles();
  const { auth } = useSelector((state) => state);
  const [refresh, setRefresh] = React.useState(false);
  const { id } = useSelector((state) => state?.auth);
  const { t } = useTranslation(['form', 'views', 'toastify']);
  const [banner, setBanner] = React.useState('');
  const [categories, setCategories] = React.useState('');
  const [categoriesLibrary, setCategoriesLibrary] = useState([])
  const [search, setSearch] = React.useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchAttributes, setSearchAttributes] = React.useState({
    text: '',
    category: '',
    subCategory: '',
  });
  const { id: user_id } = useSelector((state) => state.auth);
  

   useEffect(() => {
      const fetchData = async () => {
        try {
          const responseLibrary = await LibraryData.getLibrarystud({
            iduser: user_id,
            category: '',
            title: '',
          });
  
          const categoryMap = new Map();
          responseLibrary.data.library.forEach((item)=>{
            if(item.name) {
              categoryMap.set(item.id, {id: item.id, name: item.name});
            }
          });
  
          const uniqueCategories = Array.from(categoryMap.values());

          setCategories(uniqueCategories);
          setCategoriesLibrary(responseLibrary.data.library);
  
        } catch (err) {
          if (err.response?.status === 403) {
            toast.error(t('toastify:commons.toast_error_403'));
          } else {
            toast.error(t('toastify:commons.toast_error_api'));
          }
        }
      };
      fetchData();
    }, [user_id, t]);

    const handleSearch = () => {
      const filtered = categoriesLibrary.reduce((acc, cat) => {
        const matchedCourses = (cat.categoryLibrary || []).filter((course) => {
          const matchTitle = course.title
            .toLowerCase()
            .includes(searchAttributes.text.toLowerCase());
          const matchCategory =
            !searchAttributes.category || course.id_category === searchAttributes.category;
          return matchTitle && matchCategory;
        });
    
        if (matchedCourses.length) {
          acc.push({
            name: cat.name,
            categoryCourses: matchedCourses,
          });
        }
        return acc;
      }, []);
    
      setSearch(filtered);
      setHasSearched(true);
    };

  return (
    <>
    <div className='notranslate'>
        <Box className={classes.root}>
          <Grid container spacing={3} className={classes.titleBox}>
            <Grid item md={6} xs={12} sm={6}>
              <TextField
                label={t('form:commons.input_search')}
                variant="outlined"
                fullWidth
                value={searchAttributes.text}
                onChange={(e) =>
                  setSearchAttributes({ ...searchAttributes, text: e.target.value })
                }
                style={{ marginBottom: 16 }}
              />
            </Grid>
              <Grid item md={4} xs={12} sm={6}>
                <FormControl fullWidth variant="outlined" style={{ marginBottom: 16 }}>
                  <InputLabel>{t('form:Library.input_category')}</InputLabel>
                  <Select
                    value={searchAttributes.category}
                    onChange={(e) =>
                      setSearchAttributes({ ...searchAttributes, category: e.target.value })
                    }
                    label={t('form:commons.category')}
                  >
                    <MenuItem value="">
                      Todas
                    </MenuItem>
                    {categories &&
                      categories.map((category) => (
                        <MenuItem key={category.id} value={category.id}>
                          {category.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
                <Grid item md={2} xs={12} sm={6} >
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    style={{height: 50, width: '100%' }}
                    onClick={() => handleSearch()}
                  >
                    <Search style={{ marginRight: '5px' }} />
                    {t('button:commons.btn_advanced_filter')}
                  </Button>
                </Grid>
              </Grid>
          <Box className={classes.container}>
            {search.length ? (
              search.map((cat, index) => (
                <Box key={`${cat.name}_${index}`}>
                  <Box className={classes.titleBox}>
                    <Typography
                      component="h2"
                      className={classes.categoryHeader}
                    >
                      {cat?.name}
                    </Typography>
                  </Box>
                  <Box className={classes.cardBox}>
                    <LibrariesSlider
                      refresh={refresh}
                      courses={cat.categoryCourses}
                      user={user_id}
                    />
                  </Box>
                </Box>
              ))
            ) : hasSearched && searchAttributes.text.length ? (
              <Box className={classes.titleBox}>
                <Typography component="p" className={classes.searchHeader}>
                  <Interweave
                    content={t('views:AvalibleContent.not_found_library', {
                      search: searchAttributes.text,
                    })}
                  />
                </Typography>
              </Box>
            ) : (
              categoriesLibrary.map((cat, index) => (
                <Box key={`${cat.name}_${index}`}>
                  <Box className={classes.titleBox}>
                    <Typography
                      component="h2"
                      className={classes.categoryHeader}
                    >
                      {cat?.name}
                    </Typography>
                  </Box>
                  <Box className={classes.cardBox}>
                    <LibrariesSlider
                      refresh={refresh}
                      courses={cat.categoryLibrary}
                      user={user_id}
                    />
                  </Box>
                </Box>
              ))
            )}
          </Box>
        </Box>
    </div>
    </>
  );
};

